import { NgModule } from '@angular/core';
import { AspMakeModule } from './asp-make/asp-make.module';
import { AspModelModule } from './asp-model/asp-model.module';
import { AspYearModule } from './asp-year/asp-year.module';
import { AspVariantModule } from './asp-variant/asp-variant.module';
import { AspSparesListModule } from './asp-spares-list/asp-spares-list.module';
import { AspReplaceCartPopupComponent } from './asp-replace-cart-popup/asp-replace-cart-popup.component';
import { AspCartModule } from './asp-cart/asp-cart.module';
import { AspPaymentModule } from './asp-payment/asp-payment.module';
import { AspConfirmOrderPopupComponent } from './asp-confirm-order-popup/asp-confirm-order-popup.component';
import { AspOrderListModule } from './asp-order-list/asp-order-list.module';
import { AspLoginModule } from './asp-login/asp-login.module';
import { AspSwitchGarageModule } from './asp-switch-garage/asp-switch-garage.module';
import { AspShippingChargesPopupComponent } from './asp-shipping-charges-popup/asp-shipping-charges-popup.component';
import { AspOrderSummaryModule } from './asp-order-summary/asp-order-summary.module';
import { AspCouponDiscountPopupComponent } from './asp-coupon-discount-popup/asp-coupon-discount-popup.component';

import { AspBrandsModule } from './asp-brands/asp-brands.module';
import { AspOrderDetailsComponent } from './asp-order-details/asp-order-details.component';
import { CommonModule } from '@angular/common';
import { AspProductDetailsModule } from './asp-product-details/asp-product-details.module';
import { AspMyRequestModule} from './asp-my-request/asp-my-request.module';
import { AspRequestDetailsModule} from './asp-request-details/asp-request-details.module';
import { AspPrductCompatibilityPopupComponent } from './asp-prduct-compatibility-popup/asp-prduct-compatibility-popup.component';
import {MatTabsModule} from '@angular/material/tabs';
import { AspGarageSidebarComponent } from './asp-garage-sidebar/asp-garage-sidebar.component';
import { FormsModule } from '@angular/forms';
import { AspPlannedInventoryPopupComponent } from './asp-planned-inventory-popup/asp-planned-inventory-popup.component';
import { AspCustomerQuoteComponent } from './asp-customer-quote/asp-customer-quote.component';
import { AspPrductBottomsheetComponent } from './asp-prduct-bottomsheet/asp-prduct-bottomsheet.component';
import { AspMyReportsModule } from './asp-my-reports/asp-my-reports.module';
import { AspQuotationListModule } from './asp-quotation-list/asp-quotation-list.module';
import { AspMyBookingsModule} from './asp-my-bookings/asp-my-bookings.module';
import{AspMyJobCardsModule} from './asp-my-job-cards/asp-my-job-cards.module';
import{MyJobCardsDetailsModule} from './my-job-cards-details/my-job-cards-details.module';
// import { AspPaymentComponent } from './asp-payment/asp-payment.component';
import { AspPaymentlistModule } from './asp-paymentlist/asp-paymentlist.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list'; 
import { MatDividerModule } from '@angular/material/divider';
import { AspDynamicPopupComponent } from './asp-dynamic-popup/asp-dynamic-popup.component';
import { SideBarJobcardComponent } from './side-bar-jobcard/side-bar-jobcard.component';
// import { AspLoadingComponent } from './asp-loading/asp-loading.component';

import { LottieModule } from 'ngx-lottie';
// import player from 'lottie-web';
import { AspSearchComponent } from './asp-search/asp-search.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AspMyItemListModule } from './asp-my-item-list/asp-my-item-list.module';
import { AspJoinAutoverseModule } from './asp-join-autoverse/asp-join-autoverse.module'
import { AspViewDocumentModule } from './asp-view-document/asp-view-document.module';
import { AspMyDocumentsModule } from './asp-my-documents/asp-my-documents.module';
// import { AspMyDocumentsModule } from './asp-my-documents/asp-my-documents.module'
import { AspMyEmployeeModule } from './asp-my-employee/asp-my-employee.module';
import { AspCheckinReportsModule } from './asp-checkin-reports/asp-checkin-reports.module'
// import { AspSpareKitListModule } from './asp-spare-kit-list/asp-spare-kit-list.module';
// import { AspSpareKitDetailsModule } from './asp-spare-kit-details/asp-spare-kit-details.module';
// import { SpareKitSidebarComponent } from './spare-kit-sidebar/spare-kit-sidebar.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { AspVehicleServiceHistoryComponent } from './asp-vehicle-service-history/asp-vehicle-service-history.component';
// import { AspQuotationDetailsModule } from '../customer/asp-quotation-details/asp-quotation-details.module';
import { AspAddItemSidebarComponent } from 'app/main/auto-spare-parts/asp-add-item-sidebar/asp-add-item-sidebar.component';
import { AspFeedbackModule } from '../customer/asp-feedback/asp-feedback.module';
import { AspJobcardQuotationComponent } from './asp-jobcard-quotation/asp-jobcard-quotation.component';
import { AspInvoiceDetailsModule } from './asp-invoice-details/asp-invoice-details.module';
import { AspRecordPaymentComponent } from './asp-record-payment/asp-record-payment.component';
import { MatSelectModule } from '@angular/material/select';
import { AspCustomerPaymentsListModule } from 'app/asp-customer-payments-list/asp-customer-payments-list.module';
import { AspInvoiceListModule } from './asp-invoice-list/asp-invoice-list.module'
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AspSettingsModule } from './asp-settings/asp-settings.module';
import { AspCheckinReportModule } from '../customer/asp-checkin-report/asp-checkin-report.module';
import { AspInvoicesDetailsModule } from '../customer/asp-invoices-details/asp-invoices-details.module';
import { AspCustomerListModule } from './asp-customer-list/asp-customer-list.module';
import { AspCustomerDetailsModule } from './asp-customer-details/asp-customer-details.module';
import { AspWebsiteSettingComponent } from './asp-website-setting/asp-website-setting.component';
import { AspWebsiteSettingModule } from './asp-website-setting/asp-website-setting.module';
import { AspMyWishListComponent } from './asp-my-wish-list/asp-my-wish-list.component';
import { AspRatecardSettingComponent } from './asp-ratecard-setting/asp-ratecard-setting.component';
import { AspPaymentsCollectionsModule } from './asp-payments-collections/asp-payments-collections.module';
import { AspLearnWithAutoverseModule } from './asp-learn-with-autoverse/asp-learn-with-autoverse.module';
import { AspNetworkIssueModule } from './asp-network-issue/asp-network-issue.module';
import { AspReturnItemsComponent } from './asp-return-items/asp-return-items.component';
import { AspAutoscoreModule } from './asp-autoscore/asp-autoscore.module';
import { AspMyReturnsModule } from './asp-my-returns/asp-my-returns.module';
import { AspHelpUsImproveComponent } from './asp-help-us-improve/asp-help-us-improve.component';
// import { AspMyReturnsComponent } from './asp-my-returns/asp-my-returns.component';
import { AspInstantOrderComponent } from './asp-instant-order/asp-instant-order.component';
import { AspInstantOrderQuoteModule } from './asp-instant-order-quote/asp-instant-order-quote.module';
import { MatChipsModule } from '@angular/material/chips';
import { AspRedeemItemModule } from './asp-redeem-item/asp-redeem-item.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { AspSlotDeliveryModule } from './asp-slot-delivery/asp-slot-delivery.module';
import { AspInstantRequestComponent } from './asp-instant-request/asp-instant-request.component';
import { AspHomeModule } from './asp-home/asp-home.module';
import { AspWarrantyCertificateListModule } from './asp-warranty-certificate-list/asp-warranty-certificate-list.module';
import { AspWarrantyCertificateDetailsModule } from './asp-warranty-certificate-details/asp-warranty-certificate-details.module';
import { AspClutchKitDetailsModule } from './asp-clutch-kit-details/asp-clutch-kit-details.module';
import { AspDashboardModule } from './asp-dashboard/asp-dashboard.module';
import { AspRequestWishlistModule } from './asp-request-wishlist/asp-request-wishlist.module';
import { AspReplaceWishlistPopupComponent } from './asp-replace-wishlist-popup/asp-replace-wishlist-popup.component';
// import { AspRequestExistspopupComponent } from './asp-request-existspopup/asp-request-existspopup.component';

// export function playerFactory() {
//   return player;
// }
@NgModule({
  imports: [
    ReactiveFormsModule,
    AspMakeModule,
    AspModelModule,
    AspYearModule,
    AspVariantModule,
    AspSparesListModule,
    AspCartModule,
    AspPaymentModule,
    AspOrderListModule,
    AspLoginModule,
    AspSwitchGarageModule,
    AspOrderSummaryModule,
    AspHomeModule,
    AspBrandsModule,
    CommonModule,
    AspProductDetailsModule,
    AspClutchKitDetailsModule,
    AspMyRequestModule,
    MatTabsModule,
    AspRequestDetailsModule,
    FormsModule,
    AspMyReportsModule,
    AspQuotationListModule,
    AspMyBookingsModule,
    AspMyJobCardsModule,
    MyJobCardsDetailsModule,
    AspPaymentlistModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    AspMyDocumentsModule,
    AspViewDocumentModule,
    MatDividerModule,
    CommonModule,
    MatTooltipModule,
    AspMyItemListModule,
    AspJoinAutoverseModule,
    AspMyEmployeeModule,
    // AspQuotationDetailsModule,
    AspFeedbackModule,
LottieModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AspInvoiceDetailsModule,
    MatSelectModule,
    AspCustomerPaymentsListModule,
    AspInvoiceListModule,
    
    AspCheckinReportsModule,
    MatButtonToggleModule,
    AspSettingsModule,
    AspCheckinReportModule,
    AspCustomerListModule,
    AspCustomerDetailsModule,
    AspWebsiteSettingModule,
    AspInvoicesDetailsModule,
    AspPaymentsCollectionsModule,
    AspLearnWithAutoverseModule,
    AspNetworkIssueModule,
    AspAutoscoreModule,
    AspMyReturnsModule,
    // LottieModule.forRoot({ player: playerFactory }) 
    AspInstantOrderQuoteModule,
    MatChipsModule,
    AspRedeemItemModule,
    MatCheckboxModule,
    MatButtonModule,
    AspSlotDeliveryModule,
    AspWarrantyCertificateListModule,
    AspWarrantyCertificateDetailsModule,
    AspDashboardModule,
    AspRequestWishlistModule
  ],
  declarations: [AspReplaceCartPopupComponent, AspConfirmOrderPopupComponent, 
    AspShippingChargesPopupComponent, AspCouponDiscountPopupComponent, 
    AspOrderDetailsComponent, AspPrductCompatibilityPopupComponent, AspGarageSidebarComponent, 
    AspPlannedInventoryPopupComponent, AspCustomerQuoteComponent, AspPrductBottomsheetComponent, 
    AspDynamicPopupComponent, SideBarJobcardComponent,AspSearchComponent,AspVehicleServiceHistoryComponent,AspAddItemSidebarComponent,AspJobcardQuotationComponent,
    AspRecordPaymentComponent, AspMyWishListComponent,AspRatecardSettingComponent, AspReturnItemsComponent,
    AspHelpUsImproveComponent,AspInstantOrderComponent, AspInstantRequestComponent,
    AspReplaceWishlistPopupComponent
  ],
    
})
export class AutoSparePartsModule { }
